export const checkIfGuestOrFamily = (userRole: string): boolean => userRole === 'guest' || userRole === 'family'
